import React from 'react';

import connectData, { ConnectedProps } from '../../support/connectData';

import { Page } from '../uiold';
import AddonsList from '../PricingEditor/AddonsList';

function AddonsPage(props: FullProps) {
  let { addons, isLoading, user, saveAddons, account } = props;
  if (!user || !addons || !account) {
    return null;
  }
  return (
    <Page>
      <Page.Header title={t('Addons Pricing')} />
      <AddonsList
        account={account}
        isLoading={isLoading}
        addons={addons}
        user={user}
        saveAddons={saveAddons}
      />
    </Page>
  );
}

const connector = connectData()(
  () => ({
    addons: { dataStoreKey: 'addons' },
    user: { dataStoreKey: 'user' },
    account: { dataStoreKey: 'account' },
  }),
  () => ({
    saveAddons: { dataStoreKey: 'addons' },
  }),
);
type FullProps = ConnectedProps<typeof connector>;

export default connector(AddonsPage);
